import { TIFFormDataProps, useTIFFormData } from "../../../../hooks";
import { FormCheck, Row } from "react-bootstrap";
import { AutoCol, TextFit } from "../../../../component-library";
import { displayDateAndTime, getTerritoryName } from "../../../../helper-functions";
import { TissueTypes } from "../../../../models";

export function TIFShipping({ tissueId }: Readonly<TIFFormDataProps>) {
    const {
        tissue,
        _case,
        tissueOrder,
        packedBy,
        surgeonName,
        locationAccount,
        latestShipment,
        tissueExpirationDate,
        territories,
    } = useTIFFormData({ tissueId: tissueId });

    return (
        <>
            <TextFit style={{ maxHeight: "170px" }} maxFontSizePx={11}>
                <div style={{ fontWeight: "bold" }}>Packing:</div>
                This tissue was packed for distribution according to current{" "}
                {getTerritoryName(_case?.referral?.territoryId, territories)} SOPs.
                <Row>
                    {tissue?.tissueType?.name !== TissueTypes.Remnant && (
                        <AutoCol className="pe-4">
                            <FormCheck disabled checked={tissue?.hasBeenReturned} label="Returned Tissue" />
                        </AutoCol>
                    )}
                    <AutoCol className="pe-4">
                        Date/Time of packing: {displayDateAndTime(tissueOrder?.shipment?.shippedOn)}
                    </AutoCol>
                    <AutoCol className="pe-4">Performed by: {packedBy?.name}</AutoCol>
                </Row>
                <hr className="my-1" />
                <div style={{ fontWeight: "bold" }}>Tracking/Distribution:</div>
                <Row>
                    <AutoCol>Surgeon/Researcher: {surgeonName}</AutoCol>
                    <AutoCol>Usage Location: {locationAccount?.name}</AutoCol>
                    <AutoCol>Trans. Method: {latestShipment?.shippingMethod?.name}</AutoCol>
                    <AutoCol>
                        Tracking Number: (Flight or FedEx Air bill Number) {latestShipment?.trackingNumber}
                    </AutoCol>
                </Row>
                <div style={{ textAlign: "right" }}>Tissue Exp. Date: {displayDateAndTime(tissueExpirationDate)}</div>
            </TextFit>
            <hr className="my-1" />
        </>
    );
}
